import { render, staticRenderFns } from "./QuickRateUpdateComponent.vue?vue&type=template&id=5f6e0030&scoped=true"
import script from "./QuickRateUpdateComponent.vue?vue&type=script&lang=js"
export * from "./QuickRateUpdateComponent.vue?vue&type=script&lang=js"
import style0 from "./QuickRateUpdateComponent.vue?vue&type=style&index=0&id=5f6e0030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6e0030",
  null
  
)

export default component.exports